/* globals gettext */

import { useEffect, useRef, useState } from "preact/hooks"
import { EmergencyLink } from "./emergency-links"
import { Icon } from "./icon"
import { Text } from "./text"

export const YearSelectOptions = (props) => {
  const selection =
    props.form.inFormValues({ name: props.name })?.value ||
    gettext("--- please select ---")
  return (
    <fieldset>
      <SelectOptions
        name={props.name}
        required={props.required}
        title={selection}
        options={props.options}
        onChange={(v) => {
          props.form.toggleValue(
            {
              step: props.form.stepId,
              name: props.name,
              value: `${v}`,
              label: `${v}`,
            },
            true,
          )
        }}
      />
    </fieldset>
  )
}

export const UniversitySelectOptions = (props) => {
  const [fedData, setFedData] = useState([])
  const [uniData, setUniData] = useState([])
  const [fosData, setFosData] = useState([])
  const [polData, setPolData] = useState([])

  async function fetchData(query, setter) {
    const epData = await props.form.ep.getData(query)
    if (epData) setter(epData)
  }

  useEffect(async () => {
    fetchData("federal_states", setFedData)
  }, [])

  return (
    <fieldset>
      {fedData.length > 0 && (
        <SelectOptions
          name="federal_state"
          title={gettext("federal state")}
          options={fedData}
          onChange={(v) => {
            fetchData(`universities_for=${v}`, setUniData)
            setPolData([])
            setFosData([])
          }}
        />
      )}
      {uniData.length > 0 && (
        <SelectOptions
          name="university"
          title={gettext("university")}
          options={uniData}
          onChange={(v) => {
            props.police_stations &&
              fetchData(`police_stations_for=${v}`, setPolData)
            props.fields_of_study &&
              fetchData(`fields_of_study_for=${v}`, setFosData)
            if (!props.police_stations)
              props.form.toggleValue(
                { name: "university", value: `${v}` },
                true,
              )
          }}
        />
      )}
      {props.fields_of_study && fosData.length > 0 && (
        <>
          <Text
            class="lead"
            text={gettext(
              "In which field of study did you experience or perceive discrimination?",
            )}
          />
          <SelectOptions
            name="field_of_study"
            title={gettext("field of study")}
            options={fosData}
            onChange={(v) => {
              props.form.toggleValue(
                { name: "field_of_study", value: `${v}` },
                true,
              )
            }}
          />
          {props.form.inFormValues({ name: "field_of_study" }) && (
            <>
              <Text
                class="lead"
                text={gettext(
                  "Have you reported the harassment/discrimination to university staff?",
                )}
              />
              <SelectOptions
                name="contacted_university"
                options={[
                  { name: gettext("yes"), value: "yes" },
                  { name: gettext("no"), value: "no" },
                ]}
                onChange={(v) => {
                  props.form.toggleValue(
                    { name: "contacted_university", value: `${v}` },
                    true,
                  )
                }}
              />
            </>
          )}
          {props.form.inFormValues({
            name: "contacted_university",
            value: "yes",
          }) && (
            <>
              <Text class="lead" text={gettext("Were you helped?")} />
              <SelectOptions
                name="got_help"
                options={[
                  { name: gettext("yes"), value: "yes" },
                  { name: gettext("no"), value: "no" },
                ]}
                onChange={(v) => {
                  props.form.toggleValue(
                    { name: "got_help", value: `${v}` },
                    true,
                  )
                }}
              />
            </>
          )}
        </>
      )}

      {props.police_stations && polData.length > 0 && (
        <PoliceStations stations={polData} />
      )}
    </fieldset>
  )
}

const SelectOptions = (props) => {
  const [title, setTitle] = useState(props.title)
  const detailsRef = useRef("")

  return (
    <details
      class={`custom-select${props.required ? " required" : ""}`}
      ref={detailsRef}
    >
      <summary>
        {title}
        <Icon name="down" style="down" />
        <Icon name="close" style="close" />
      </summary>
      <div>
        {props.options.map((opt) => (
          <label key={`opt-${props.name}-${opt.value}`}>
            <span>{opt.name}</span>
            <input
              name={props.name}
              value={opt.value}
              type="radio"
              onChange={(v) => {
                const val = v.currentTarget.value
                props.onChange(val)
                setTitle(opt.name)
                detailsRef.current?.removeAttribute("open")
              }}
            />
          </label>
        ))}
      </div>
    </details>
  )
}

const PoliceStations = ({ stations }) => {
  return (
    <div>
      {stations.map((station) => (
        <>
          <Text
            key={station.pk}
            heading={station.name}
            text={station.address}
          />
          <EmergencyLink
            key={station.pk}
            url={`tel:${station.phone}`}
            linktext={station.phone}
          />
        </>
      ))}
    </div>
  )
}
